import { MGPFallible } from '@everyboard/lib';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { MoveWithTwoCoords } from '../../jscaip/MoveWithTwoCoords';
import { Ordinal } from '../../jscaip/Ordinal';
import { LinesOfActionState } from './LinesOfActionState';
export class LinesOfActionMove extends MoveCoordToCoord {
    direction;
    static encoder = MoveWithTwoCoords.getFallibleEncoder(LinesOfActionMove.from);
    static from(start, end) {
        const directionOptional = Ordinal.factory.fromMove(start, end);
        if (directionOptional.isFailure()) {
            return MGPFallible.failure(directionOptional.getReason());
        }
        if (start.isNotInRange(LinesOfActionState.SIZE, LinesOfActionState.SIZE)) {
            return MGPFallible.failure('start coord is not in range');
        }
        if (end.isNotInRange(LinesOfActionState.SIZE, LinesOfActionState.SIZE)) {
            return MGPFallible.failure('end coord is not in range');
        }
        return MGPFallible.success(new LinesOfActionMove(start, end, directionOptional.get()));
    }
    constructor(start, end, direction) {
        super(start, end);
        this.direction = direction;
        this.direction = Ordinal.factory.fromMove(start, end).get();
    }
    toString() {
        return 'LinesOfActionMove(' + this.getStart() + '->' + this.getEnd() + ')';
    }
}
